import React, { Component } from 'react';
import { Message } from 'rebass';
import styled from 'styled-components';
import Close from '@material-ui/icons/Close';

const RelativeMessage = styled(Message)`
  position: relative;
`;

const CloseBtn = styled(Close)`
  position: absolute;
  top: 2px;
  right: 2px;
  cursor: pointer;
  font-size: 18px !important;
`;

class DismissableMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true
    };

    const dismiss = () => {
      this.setState({visible: false});
    };

    this.dismiss = dismiss.bind(this);
  }

  render() {
    const {children} = this.props;

    const {visible} = this.state;

    if (visible) {
      return (
        <RelativeMessage
          {...this.props}
          position='relative'>
          <CloseBtn onClick={() => this.dismiss()}/>
          {children}
        </RelativeMessage>
      );
    } else {
      return null;
    }
  }
}

export default DismissableMessage;


// WEBPACK FOOTER //
// ./src/components/DismissableMessage.jsx